import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const AccountProductShortPage = lazy(() => import('../views/list/AccountProductShortPage'));

export function AccountProductShortPageLazy() {
	return (
		<PageSuspense>
			<AccountProductShortPage />
		</PageSuspense>
	);
}
